(function() {
  'use strict';

  angular.module('component.accounts', []);
})();
